import { useMemo } from 'react'
import { useSuspenseQuery } from '@apollo/client/react'
import { AdminAPI, getFragment, SharedAPI } from '@guestgoodie/graphql'
import { useParams } from 'wouter'
import { useLingui } from '@lingui/react/macro'

import { Suspense } from '@/components/ui/Suspense'
import { DialogHeader } from '@/layouts/Dialog'
import { GuestForm } from '@/features/guest'
import { useCloseModal } from '@/Router'

function Guest({ token }: { token: string }) {
  const { t } = useLingui()
  const closeModal = useCloseModal()

  const { data } = useSuspenseQuery(AdminAPI.guest.GET_BY_TOKEN, {
    variables: { token }
  })

  const guest = useMemo(() => {
    if (!data) return

    return getFragment(SharedAPI.guest.GUEST_FRAGMENT, data.getGuestByToken)
  }, [data])

  if (!guest) return null

  const guestName = `${guest.firstName} ${guest.lastName}`

  return (
    <div className="flex flex-col gap-7 p-5">
      <DialogHeader
        title={guestName}
        description={t`Details of the guest with the name \"${guestName}\".`}
      />
      <GuestForm id={guest.id} onDone={closeModal} />
    </div>
  )
}

export default function GuestSuspense() {
  const params = useParams() as { token: string }

  if (!params) return null

  return (
    <Suspense isDialog>
      <Guest token={params.token} />
    </Suspense>
  )
}
